import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import { CheckCircle2, Loader2, XCircle, ArrowRight } from "lucide-react";

export default function PaymentSuccessPage() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState("checking");
  const [orderNumber, setOrderNumber] = useState(null);
  const tries = useRef(0);

  useEffect(() => {
    if (!sessionId) { setState("error"); return; }
    let stop = false;
    const poll = async () => {
      if (stop || tries.current > 10) { if (tries.current > 10) setState("timeout"); return; }
      tries.current += 1;
      try {
        const r = await api.get(`/payments/status/${sessionId}`);
        if (r.data.payment_status === "paid") {
          setOrderNumber(r.data.order_number);
          setState("paid");
          return;
        }
        if (["failed", "expired"].includes(r.data.payment_status)) { setState("failed"); return; }
      } catch { /* retry */ }
      setTimeout(poll, 2000);
    };
    poll();
    return () => { stop = true; };
  }, [sessionId]);

  return (
    <div data-testid="payment-success-page" className="max-w-xl mx-auto px-6 py-24 text-center">
      {state === "checking" && (
        <>
          <Loader2 className="w-14 h-14 text-[#00E5FF] mx-auto mb-6 animate-spin" />
          <h1 className="font-display text-2xl uppercase">Verificam plata...</h1>
          <p className="text-neutral-500 text-sm mt-3">Nu inchide pagina, dureaza cateva secunde.</p>
        </>
      )}
      {state === "paid" && (
        <>
          <CheckCircle2 className="w-16 h-16 text-green-400 mx-auto mb-6" />
          <h1 className="font-display text-3xl uppercase">Plata <span className="text-[#00E5FF]">confirmata!</span></h1>
          {orderNumber && (
            <>
              <div className="text-neutral-400 mt-4">Numarul comenzii tale:</div>
              <div data-testid="paid-order-number" className="font-mono font-bold text-2xl text-[#00E5FF] mt-1">{orderNumber}</div>
            </>
          )}
          <p className="text-sm text-neutral-500 mt-4">Pregatim coletul si te anuntam cand pleaca spre tine. Multumim!</p>
        </>
      )}
      {(state === "failed" || state === "error" || state === "timeout") && (
        <>
          <XCircle className="w-16 h-16 text-red-400 mx-auto mb-6" />
          <h1 className="font-display text-2xl uppercase">{state === "timeout" ? "Verificarea dureaza mai mult" : "Plata nu a fost confirmata"}</h1>
          <p className="text-sm text-neutral-500 mt-3">
            {state === "timeout" ? "Daca banii s-au retras, comanda ta e inregistrata — te contactam noi. Suna-ne la 0743 110 277 pentru confirmare." : "Poti incerca din nou din cosul tau."}
          </p>
        </>
      )}
      <Link to="/magazin" className="inline-flex items-center gap-2 bg-[#00E5FF] text-black font-bold px-6 py-3 uppercase tracking-wider text-sm mt-10 hover:bg-[#5CEEFF] transition-colors">
        Inapoi la magazin <ArrowRight className="w-4 h-4" />
      </Link>
    </div>
  );
}
